import Component from "@base/js/component";

export default class ThemeBar extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".theme-bar";

  constructor() {
    super();

    this.appendClassToAllArticleBodies =
      this.appendClassToAllArticleBodies.bind(this);
  }

  // Will be called upon component instantiation
  afterInit() {
    this.appendClassToAllArticleBodies();
  }

  appendClassToAllArticleBodies() {
    const allArticleBodies = document.querySelectorAll(".article-body");
    const allPublicationHero = document.querySelectorAll(".publication-hero");
    const { theme } = this.element.dataset;

    if (!allArticleBodies.length || !theme) return false; // do nothing

    [allArticleBodies, allPublicationHero].forEach((arrays) => {
      arrays.forEach((array) => {
        const baseClass = array.classList[0]; // assuming it's always at the start

        array.classList.add(`${baseClass}--${theme}`);
      });
    });
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
ThemeBar.init();
